export const  RECORDS_LOAD_LIMIT= 20


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/common/constants.js